import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/pareto-type1/cdf';
import __var_2__ from '@stdlib/stats/base/dists/pareto-type1/ctor';
import __var_3__ from '@stdlib/stats/base/dists/pareto-type1/entropy';
import __var_4__ from '@stdlib/stats/base/dists/pareto-type1/kurtosis';
import __var_5__ from '@stdlib/stats/base/dists/pareto-type1/logcdf';
import __var_6__ from '@stdlib/stats/base/dists/pareto-type1/logpdf';
import __var_7__ from '@stdlib/stats/base/dists/pareto-type1/mean';
import __var_8__ from '@stdlib/stats/base/dists/pareto-type1/median';
import __var_9__ from '@stdlib/stats/base/dists/pareto-type1/mode';
import __var_10__ from '@stdlib/stats/base/dists/pareto-type1/pdf';
import __var_11__ from '@stdlib/stats/base/dists/pareto-type1/quantile';
import __var_12__ from '@stdlib/stats/base/dists/pareto-type1/skewness';
import __var_13__ from '@stdlib/stats/base/dists/pareto-type1/stdev';
import __var_14__ from '@stdlib/stats/base/dists/pareto-type1/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace pareto1
*/
var pareto = {};

/**
* @name cdf
* @memberof pareto1
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/pareto-type1/cdf}
*/
setReadOnly( pareto, 'cdf', __var_1__);

/**
* @name Pareto1
* @memberof pareto1
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/pareto-type1/ctor}
*/
setReadOnly( pareto, 'Pareto1', __var_2__);

/**
* @name entropy
* @memberof pareto1
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/pareto-type1/entropy}
*/
setReadOnly( pareto, 'entropy', __var_3__);

/**
* @name kurtosis
* @memberof pareto1
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/pareto-type1/kurtosis}
*/
setReadOnly( pareto, 'kurtosis', __var_4__);

/**
* @name logcdf
* @memberof pareto1
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/pareto-type1/logcdf}
*/
setReadOnly( pareto, 'logcdf', __var_5__);

/**
* @name logpdf
* @memberof pareto1
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/pareto-type1/logpdf}
*/
setReadOnly( pareto, 'logpdf', __var_6__);

/**
* @name mean
* @memberof pareto1
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/pareto-type1/mean}
*/
setReadOnly( pareto, 'mean', __var_7__);

/**
* @name median
* @memberof pareto1
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/pareto-type1/median}
*/
setReadOnly( pareto, 'median', __var_8__);

/**
* @name mode
* @memberof pareto1
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/pareto-type1/mode}
*/
setReadOnly( pareto, 'mode', __var_9__);

/**
* @name pdf
* @memberof pareto1
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/pareto-type1/pdf}
*/
setReadOnly( pareto, 'pdf', __var_10__);

/**
* @name quantile
* @memberof pareto1
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/pareto-type1/quantile}
*/
setReadOnly( pareto, 'quantile', __var_11__);

/**
* @name skewness
* @memberof pareto1
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/pareto-type1/skewness}
*/
setReadOnly( pareto, 'skewness', __var_12__);

/**
* @name stdev
* @memberof pareto1
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/pareto-type1/stdev}
*/
setReadOnly( pareto, 'stdev', __var_13__);

/**
* @name variance
* @memberof pareto1
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/pareto-type1/variance}
*/
setReadOnly( pareto, 'variance', __var_14__);


// EXPORTS //
export default pareto;

export { __var_1__ as cdf, __var_2__ as Pareto1, __var_3__ as entropy, __var_4__ as kurtosis, __var_5__ as logcdf, __var_6__ as logpdf, __var_7__ as mean, __var_8__ as median, __var_9__ as mode, __var_10__ as pdf, __var_11__ as quantile, __var_12__ as skewness, __var_13__ as stdev, __var_14__ as variance};